module.exports = __webpack_public_path__ + "img/media_isp.e31a286e.jpg";